import { ApiRequest } from '../../api/request';
import { DataResponse } from '@fino/ng1-response/lib';

export class BankSearchService extends ApiRequest {
  constructor($http, $q) {
    'ngInject';
    super({ $http, $q});
  }

  resourceSearch(search) {
    return this.$http({
      method: 'GET',
      url: `/api/banks/${search}?limit=10`,
      error: {
        silent: true
      }
    }).then(DataResponse.transform('data.banks'));
  }

  getDisplayName(entry) {
    return entry.shortName || entry.name;
  }

  getIdentifier(entry) {
    // bankCode is filled when bank selected from list, otherwise using user entered data
    return entry.bankCode || entry.name;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/data/source/bankSearchSource.js